
<script>
import { Radar } from "vue-chartjs";

export default {
  extends: Radar,
  name: "RadarChart",
  props: ["radarData"],
  mounted() {

    this.addPlugin({
      beforeDraw: function (c) {
        var ctx = c.chart.ctx;
        ctx.fillStyle = "#fff";
        // ctx.fillRect(0, 0, c.chart.width, c.chart.height);
        ctx.beginPath(150,31);
        ctx.moveTo(150,31);
        ctx.lineTo(26,122);
        ctx.lineTo(73,268);
        ctx.lineTo(227,268);
        ctx.lineTo(274,121);   //直線を追加して三角形にします。
        ctx.closePath();  //moveTo()で指定した始点に向けて線を引き、領域を閉じます。
        ctx.fill();  //stroke()では輪郭線を描き、fill()にすると中を塗りつぶします。

        ctx.save();
      }
    });    
    this.renderChart(
      { 
        labels: ["精神", "社交", "献身", "計画", "挑戦"],

        datasets: [     
          {
            type: "radar",
            backgroundColor: "rgba(24,136,222,0.9)",
            data: this.radarData,            
            datalabels: {
              formatter: function () {
                return "";
              },
            },
          },
        ],
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false,       
        },
        tooltips: {
          enabled:false
        },
        scale: {
          pointLabels: {
            fontSize: 15
          },
          angleLines: {
            display: true,
            color: "#eee",
            fill:true,
          },
          ticks: {
            display:false,
            suggestedMin: 0,
            suggestedMax: 10,
            stepSize: 2,
          },
        },
      }
    );
  },
};
</script>